export default __webpack_public_path__ + "static/media/paint.cbd3f6e9.png";